import { allModelsSelector, singleModelSelector } from 'common-src/utils/selectorUtils';

export const getPatientCgmOrders = (state, patientId) =>
  allModelsSelector(state, 'PatientCgmOrder', (pco) => pco.patientId === patientId).sort(
    (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
  );

export const getPatientSingleCgmOrder = (state, id) =>
  singleModelSelector(state, 'PatientCgmOrder', id);
